import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isNilOrEmpty, notEqual } from 'ramda-adjunct';
import { path, pathOr } from 'ramda';
import { EditOutlined } from '@ant-design/icons';
import { Components } from '@fasstech/flexiget';

const FrameCommentInput = ({ comment, frameId, handleCommentChange }) => {
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [showAddComment, setShowAddComment] = useState(true);
  const [commentValue, setCommentValue] = useState(comment);

  const handleOnBlurOrPressEnter = (e) => {
    const currentValue = pathOr('', ['target', 'value'], e);
    const shouldUpdate = notEqual(comment, currentValue);

    shouldUpdate && handleCommentChange(frameId, e);
    setShowCommentInput(false);
    setShowAddComment(true);
  };

  useEffect(() => {
    setCommentValue(comment);
  }, [comment]);

  return (
    <>
      <div className="flex items-center w-250px">
        {showCommentInput ? (
          <Input
            autoFocus
            allowClear
            value={commentValue}
            onChange={(e) => setCommentValue(path(['target', 'value'], e))}
            onBlur={handleOnBlurOrPressEnter}
            onPressEnter={handleOnBlurOrPressEnter}
          />
        ) : (
          <Components.Tooltip title={comment}>
            <p
              className="truncate"
              onClick={() => setShowCommentInput(true)}
            >
              {comment}
            </p>
          </Components.Tooltip>
        )}
      </div>
      {isNilOrEmpty(comment) && showAddComment && (
        <div className="flex items-center w-250px">
          <Components.Tooltip
            title="Ajouter un commentaire"
            onClick={() => {
              setShowCommentInput(true);
              setShowAddComment(!showAddComment);
            }}
            className="ml-2"
          >
            <EditOutlined className="!text-flexi-grey"/>
          </Components.Tooltip>
        </div>
      )}
    </>
  );
};

FrameCommentInput.propTypes = {
  comment: PropTypes.string,
  frameId: PropTypes.string,
  handleCommentChange: PropTypes.func
};

export default FrameCommentInput;
